import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/* Journeys are set up and followed by Wundo's own people, behind the same inner door as `/admin`. */
export const Route = createFileRoute('/_app/journeys')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: Outlet,
});
